import axios from 'axios';
import { useEffect, useState } from 'react';
import { getAccountAnalysisState } from 'utils/account';
import { getSSOToken } from 'utils/teams';
import * as Sentry from "@sentry/react";

const AnalysingBadge = () => {
  const [isAnalysing, setIsAnalysing] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();

    // Fetching recordings in the background.
    // TODO: Fetch recordings on an interval.
    (async (signal: AbortSignal) => {
      try {
        const ssoToken = await getSSOToken();

        if (!ssoToken) {
          throw new Error('SSO token not found');
        }

        const analysisState = await getAccountAnalysisState(ssoToken, signal);
        setIsAnalysing(analysisState.pending.length > 0);
      } catch (err) {
        if (axios.isCancel(err)) {
          return;
        }
        Sentry.captureException(err);
      }
    })(abortController.signal);

    return () => { abortController.abort(); };
  }, []);

  return (
    <div className='flex items-center justify-center'>
      {isAnalysing && (
        <div
          className='
            py-1.5 px-3
            flex gap-1.5 items-center
            bg-green-100
            rounded-md
          '
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='12'
            height='12'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M10 2V9.527C10.0003 9.83801 9.92806 10.1448 9.78902 10.423L4.72002 20.55C4.64293 20.703 4.60643 20.8732 4.61402 21.0444C4.62162 21.2155 4.67305 21.3818 4.7634 21.5274C4.85374 21.6729 4.97997 21.7928 5.12997 21.8756C5.27997 21.9584 5.44871 22.0012 5.62002 22H18.38C18.5513 22.0012 18.7201 21.9584 18.8701 21.8756C19.0201 21.7928 19.1463 21.6729 19.2366 21.5274C19.327 21.3818 19.3784 21.2155 19.386 21.0444C19.3936 20.8732 19.3571 20.703 19.28 20.55L14.211 10.423C14.072 10.1448 13.9997 9.83801 14 9.527V2M8.5 2H15.5M7 16H17'
              stroke='#388E3C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <span className='text-sm text-green-700'>
            Analysing
          </span>
        </div>
      )}
    </div>
  );
};

export default AnalysingBadge;
